import React, { Component } from 'react';
import GeneralPage from './GeneralPage'

class NewsPage extends Component {
  render() {
    return (
      <GeneralPage 
        enUID="news-and-events"
        frUID="infos-et-evenements"
      />
    )
  }
}

export default NewsPage


// WEBPACK FOOTER //
// ./src/pages/NewsPage.js